<template>
  <div class="insights-highlights-unusual-activity">
    <InsightsUnusualActivityWidgetContainer
      :key="hash"
      v-slot="{
        data,
        isLoading,
        period,
        previous60DaysTotalDuration,
        sort,
        sortOptions,
        totalDuration,
        totalInstances,
        totalInstancesByConfidenceLevels,
        totalMembers,
        monthlyTotal,
      }"
      :widget-key="widgetKey"
      :limit="INSIGHTS.parameters.unusualActivityLimit"
    >
      <div class="widget-title pb-20">
        <div class="">Unusual activity</div>
        <i
          v-tooltip="tooltipOptions"
          class="hi hi-info-filled ml-8"
          :title="tooltipContent"
        />
      </div>
      <div
        class="d-flex z-bg-white"
        style="max-width: 900px"
      >
        <div class="ua-left border-rounded border p-20">
          <InsightsUnusualActivityWidgetSummary
            :user-view="!!userId"
            :total-instances-by-confidence-levels="totalInstancesByConfidenceLevels"
            :total-instances="totalInstances"
            :total-members="totalMembers"
            :total-duration="totalDuration"
            :previous-days-total-duration="previous60DaysTotalDuration"
            :is-loading="isLoading"
            class="flex-column"
          />
        </div>
        <div class="ua-right border-rounded flex-auto border px-20">
          <InsightsUnusualActivityWidgetHighlights
            v-if="((totalInstances || totalMembers || totalDuration) && !isLoading) || isLoading"
            :time-zone="timeZone"
            :data="data"
            :period="period"
            :is-loading="isLoading"
            :sort="sort"
            :sort-options="sortOptions"
            class="flex-auto"
          />
          <InsightsNoData v-else-if="!isLoading">
            <template #title>
              <div class="bold">That's good news!</div>
            </template>
            <template #description>
              <span>No unusual activity was recorded for the selected time period</span>
            </template>
            <template
              v-if="monthlyTotal"
              #footer
            >
              <InsightsUnusualActivityInvestigateNow
                border
                text
                :mode="'simple'"
                :monthly-total="monthlyTotal"
                :organization-insights-url="organizationInsightsUrl"
                :period="period"
                :query-date="queryDate"
                :user-id="userId"
                :team-id="teamId"
                class="mt-10"
              />
            </template>
          </InsightsNoData>
        </div>
      </div>
    </InsightsUnusualActivityWidgetContainer>
  </div>
</template>

<script>
import InsightsNoData from '~/components/insights/InsightsNoData.vue';
import InsightsUnusualActivityWidgetHighlights from '~/components/insights/InsightsUnusualActivityWidgetHighlights.vue';
import InsightsUnusualActivityWidgetContainer from '~/components/insights/InsightsUnusualActivityWidgetContainer.vue';
import InsightsUnusualActivityWidgetSummary from '~/components/insights/InsightsUnusualActivityWidgetSummary.vue';
import { INSIGHTS } from '~/app_constants';
import { mapGetters, mapState } from 'vuex';
import InsightsUnusualActivityInvestigateNow from '~/components/insights/InsightsUnusualActivityInvestigateNow.vue';
import { unusualActivityWidgetKey } from '~/utils/insights_filter';

export default {
  name: 'InsightsHighlightsUnusualActivity',
  components: {
    InsightsUnusualActivityInvestigateNow,
    InsightsNoData,
    InsightsUnusualActivityWidgetHighlights,
    InsightsUnusualActivityWidgetContainer,
    InsightsUnusualActivityWidgetSummary,
  },
  props: {
    timeZone: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      INSIGHTS,
      tooltipOptions: Object.freeze({ html: true, sanitize: false }),
      tooltipContent: INSIGHTS.tooltips.unusualActivity.content,
    };
  },
  computed: {
    ...mapState(['filters']),
    ...mapState({
      organizationInsightsUrl: 'organization_insights_url',
    }),
    ...mapGetters(['queryDate', 'userId']),
    teamId() {
      return this.filters?.team_id;
    },
    hash() {
      // time_zone/time_zone_mode excluded: a zone change must refetch, not remount, or the
      // widget's local sort/page state resets with it (see InsightsUnusualActivity.vue).
      return unusualActivityWidgetKey(this.filters, ['time_zone', 'time_zone_mode']);
    },
    widgetKey() {
      return this.userId ? INSIGHTS.api.unusualActivity.individual : INSIGHTS.api.unusualActivity.team;
    },
  },
};
</script>
